import cookies from 'js-cookie';
import { AkamaiCookie } from '../utils/akamaiCookies';
import * as locationParser from '../zipcode-service/utils/locationParser';
export default async function queueCoxAutoDataLayer({
  dataLayer = {},
  data = {}
}) {
  globalThis.coxAutoDataLayer = globalThis.coxAutoDataLayer || [];
  const {
    consumeradtargetswithoutcampdata,
    consumeradtargetsdata,
    consumermarketingsegmentsdata,
    consumerinsightsdata,
    editorial,
    googleanalytics = {},
    info,
    mykbb = {},
    syc,
    service,
    vehicleSearch,
    location,
    peIds,
    peAddedByRule
  } = dataLayer;
  const logInSource = cookies.get('MyConsumerSignedIn') || 0;
  const akamaiLocation = locationParser.decodeAsAkami(cookies.get(AkamaiCookie));
  const commonDataLayer = {
    page: {
      hierarchy: [googleanalytics.common?.page?.siteSection, googleanalytics.common?.page?.pageType, googleanalytics.common?.page?.detailPageName]
    },
    user: {
      isInternalUser: String(!!mykbb.isInternalUser),
      logInSource: String(logInSource),
      zipCode: akamaiLocation?.akamaizip
    },
    search: {
      zipCode: location?.zip
    },
    peSnapshotId: null
  };
  if (syc) {
    commonDataLayer.syc = {
      purchaseOrEditPath: syc.purchasePath,
      orderId: syc.orderId
    };
  }
  if (service) {
    commonDataLayer.service = {
      customerSource: service.customerSource
    };
  }
  if (info) {
    commonDataLayer.vehicle = {
      bodyStyleGroup: info.type,
      descriptionExists: info.description,
      driveTrain: info.driveTrain,
      fuelType: info.fuelType,
      legacyConfigurationId: info.vehicleId,
      productConfiguration: info.productConfiguration,
      sellerType: info.sellerType,
      seriesId: info.seriesId,
      subCategory: info?.categories?.sub?.code,
      transmission: info.transmission,
      trimId: info.trimId,
      vin: info.vin,
      licensePlate: info.licensePlate
    };
  }
  if (vehicleSearch) {
    commonDataLayer.vehicleSearch = {
      searchKeywords: vehicleSearch.searchKeywords,
      vehicleHistory: vehicleSearch.vehicleHistory,
      vehicleSellerType: vehicleSearch.vehicleSellerType,
      atHomeVehicleServices: vehicleSearch.atHomeVehicleServices
    };
  }
  if (googleanalytics.ico) {
    const {
      ico
    } = googleanalytics;
    commonDataLayer.ico = {
      offerCode: ico.offerCode,
      optionToSell: ico.optionToSell,
      entryPoint: ico.entryPoint,
      responseFields: ico.responseFields,
      responseValues: ico.responseValues,
      path: ico.path,
      offerStatus: ico.offerStatus,
      filterResults: ico.filterResults,
      searchDetails: ico.searchDetails,
      profileId: ico.profileID,
      vehicleEntry: ico.vehicleEntry,
      offerId: ico.offerId
    };
  }
  if (editorial) {
    commonDataLayer.editorial = {
      author: editorial.author,
      modifiedDate: editorial.modifiedDate,
      publishedDate: editorial.publishedDate,
      searchKeywords: editorial.searchKeywords
    };
  }
  if (consumerinsightsdata?.insights) {
    const {
      insights
    } = consumerinsightsdata;
    commonDataLayer.consumerInsights = {
      apiTrackingId: peIds?.ids?.peTrackingId,
      fixedOps: insights.fixedOps,
      makeBodystyleLoyalty: insights.makeBodystyleLoyalty,
      marketLevel: insights.marketLevel,
      marketLevelConfidence: insights.marketLevelConfidence,
      preferredBodystyle: insights.preferredBodystyle,
      preferredBodystyleConfidence: insights.preferredBodystyleConfidence,
      preferredMake: insights.preferredMake,
      preferredMakeConfidence: insights.preferredMakeConfidence,
      preferredMileage: insights.preferredMileage,
      preferredMileageConfidence: insights.preferredMileageConfidence,
      preferredModel: insights.preferredModel,
      preferredModelConfidence: insights.preferredModelConfidence,
      preferredPrice: insights.preferredPrice,
      preferredPriceConfidence: insights.preferredPriceConfidence,
      preferredVehicleType: insights.preferredVehicleType,
      preferredVehicleTypeConfidence: insights.preferredVehicleTypeConfidence,
      priceSensitivity: insights.priceSensitivity,
      recentActivityPreferredMake: insights.recentActivityPreferredMake,
      recentActivityPreferredModel: insights.recentActivityPreferredModel,
      secondPreferredFuelCategory: insights.secondPreferredFuelCategory,
      secondPreferredMake: insights.secondPreferredMake,
      secondPreferredModel: insights.secondPreferredModel
    };
  }
  if (consumermarketingsegmentsdata) {
    commonDataLayer.consumerMarketingSegments = {
      demographics: consumermarketingsegmentsdata.demographics,
      lifeevents: consumermarketingsegmentsdata.lifeEvents,
      clusters: consumermarketingsegmentsdata.clusters
    };
  }
  if (consumeradtargetswithoutcampdata) {
    commonDataLayer.consumerAdTargetsWithoutCAMPBias = {
      preferredModel: consumeradtargetswithoutcampdata.preferredModel,
      secondPreferredModel: consumeradtargetswithoutcampdata.secondPreferredModel,
      preferredMakes: consumeradtargetswithoutcampdata.preferredMakes,
      subCategory: consumeradtargetswithoutcampdata.subCategory,
      intent: consumeradtargetswithoutcampdata.intent,
      tradeInMake: consumeradtargetswithoutcampdata.tradeInMake,
      tradeInModel: consumeradtargetswithoutcampdata.tradeInModel
    };
  }
  if (consumeradtargetsdata) {
    commonDataLayer.consumerAdTargets = {
      consumerAdTargetInsightsAvailable: consumeradtargetsdata.targetInsightsAvailable,
      consumerCampaignPreferencesAddedByRule: peAddedByRule
    };
  }
  globalThis.coxAutoDataLayer.push(commonDataLayer);
}